import React, { useContext } from "react";
import { logout } from "../../utils/auth";
import Button from "../../components/Button";
import { FurnitureContext } from "../../utils/furniture";
import { Container, ModalText, ButtonContainer } from "./styles";

const ModalScreen = ({ navigation }) => {
	const {
		strings: { deleteDataAreYouSure, yesDeleteCta, noDeleteCta },
	} = useContext(FurnitureContext);
	return (
		<Container>
			<ModalText type="h1">{deleteDataAreYouSure}</ModalText>
			<ButtonContainer>
				<Button type="default" title={yesDeleteCta} onPress={logout} />
			</ButtonContainer>

			<ButtonContainer>
				<Button
					type="default"
					title={noDeleteCta}
					onPress={() => navigation.goBack()}
				/>
			</ButtonContainer>
		</Container>
	);
};

export default ModalScreen;
